import theme from '@app/ui/theme'
import styled from 'styled-components'

export const Header = styled.div`
  padding: 28px 28px 20px;
  background: ${theme.colors.light2};
  border-bottom: 1px solid ${theme.colors.light};
  color: ${theme.colors.primary};
`

export const Title = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 0.01em;
`

export const Subtitle = styled.p`
  margin: 10px 0 0;
  font-size: 15px;
  line-height: 1.55;
  color: ${theme.colors.secondary};
`

export const TeePill = styled.div`
  margin-top: 16px;
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid ${theme.colors.light};
  background: ${theme.colors.white};
  color: ${theme.colors.primary};
  font-size: 13px;
  font-weight: 700;
`

export const Body = styled.div`
  padding: 20px 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const OptionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const OptionCard = styled.div`
  border: 1px solid ${theme.colors.light};
  background: ${theme.colors.light3};
  border-radius: 12px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const OptionTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  color: ${theme.colors.primary};
`

export const OptionText = styled.p`
  margin: 0;
  min-height: 42px;
  font-size: 13px;
  line-height: 1.45;
  color: ${theme.colors.secondary};
`

export const OptionButton = styled.button<{ $variant: 'primary' | 'secondary' }>`
  border-radius: 10px;
  border: 1px solid
    ${({ $variant }) =>
      $variant === 'primary' ? theme.colors.secondary2 : theme.colors.light};
  background: ${({ $variant }) =>
    $variant === 'primary' ? theme.colors.secondary2 : theme.colors.white};
  color: ${({ $variant }) =>
    $variant === 'primary' ? theme.colors.white : theme.colors.primary};
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
`

export const Note = styled.div`
  border: 1px solid ${theme.colors.light};
  background: ${theme.colors.light3};
  border-radius: 10px;
  padding: 10px 12px;
  color: ${theme.colors.secondary};
  font-size: 13px;
  line-height: 1.45;
`

export const ResetSourceRow = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid ${theme.colors.light};
  background: ${theme.colors.light3};
  border-radius: 10px;
  cursor: pointer;
  user-select: none;
`

export const ResetSourceCheckbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
`

export const ResetSourceLabel = styled.span`
  font-size: 14px;
  color: ${theme.colors.primary};
`

export const CancelButton = styled.button`
  border: 1px solid ${theme.colors.light};
  background: ${theme.colors.white};
  color: ${theme.colors.primary};
  border-radius: 10px;
  padding: 10px 16px;
  min-width: 110px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
`
